import { CloseOutlined } from '@ant-design/icons'
import { Button, InputNumber, Select } from 'antd'
import { FC } from 'react'
import styled, { DefaultTheme } from 'styled-components'
import { ColorantCellDraft } from './types'

export type ColorantCellState = 'default' | 'changed' | 'error'

const borderColors: Record<ColorantCellState, (theme: DefaultTheme) => string> = {
    default: theme => theme.colorBorder,
    changed: theme => theme.colorWarning,
    error: theme => theme.colorError,
}

const CellStyled = styled.div<{ $state: ColorantCellState }>`
    display: flex;
    align-items: center;
    border: 1px solid ${({ theme, $state }) => borderColors[$state](theme)};
    border-radius: ${({ theme }) => theme.borderRadius}px;
    background: ${({ theme }) => theme.colorBgContainer};
`

const ColorantSelect = styled(Select)`
    width: 160px;
`

const AmountInput = styled(InputNumber)`
    width: 100px;
`

interface ColorantCellProps {
    value: ColorantCellDraft
    state: ColorantCellState
    options: { value: string; label: string }[]
    readOnly?: boolean // состав виден, но не редактируется
    onChange: (value: ColorantCellDraft) => void
    onRemove: () => void
}

const ColorantCell: FC<ColorantCellProps> = ({
    value,
    state,
    options,
    readOnly,
    onChange,
    onRemove,
}) => (
    <CellStyled $state={state}>
        <ColorantSelect
            variant='borderless'
            showSearch
            optionFilterProp='label'
            placeholder='Колорант'
            options={options}
            disabled={readOnly}
            value={value.colorantDocumentId ?? undefined}
            onChange={colorant => onChange({ ...value, colorantDocumentId: colorant as string })}
        />
        <AmountInput
            variant='borderless'
            min={0}
            placeholder='0'
            addonAfter='г'
            disabled={readOnly}
            status={state === 'error' ? 'error' : undefined}
            value={value.amount}
            onChange={amount => onChange({ ...value, amount: amount as number | null })}
        />
        {!readOnly && (
            <Button type='text' size='small' icon={<CloseOutlined />} onClick={onRemove} />
        )}
    </CellStyled>
)

export default ColorantCell
